




























































































































































































































































































































































	import { Component, Vue } from 'vue-property-decorator'
	import HeadLable from '@/components/HeadLable/index.vue'
	import ImageUpload from '@/components/ImgUpload/index.vue'

  import {
    addOrder,
    uploadFile,
    queryResvDetailById,
    updateOrder,
    getCompanyByCompanyName,
    getDataByIdCard,
    getDataByCert,
    orderPrint,
    queryResvDetailByCertificateNumber,
    companyFuzzyQuery,
    queryResvDetail, getOrderDetailPage, getUserList
  } from '@/api/order'  //把接口方法导入
import { Message } from 'element-ui'
  import axios from 'axios'

	@Component({
		name: 'addShop',
		components: {
			HeadLable,
			ImageUpload

		}
	})
	export default class extends Vue {
		private title = '添加预约人信息'
		private actionType = 'add'
		private imageUrl = ''
    private audioContext = null
    private soundConfig = {
      type: 'square',        // 音色：sine/square/triangle/sawtooth
      initFreq: 400,       // 初始音调（越高越尖）
      endFreq: 400,        // 结束音调（越低越沉）
      volume: 1.0,         // 音量（0-1，建议0.05-0.2）
      duration: 0.3,       // 播放时长（秒）
      fadeTime: 0.3        // 音调/音量渐变时间（和duration一致即可）
    }
    private dialogImageUrl = ''
    private dialogVisible = false
    private hasRedirected = false
		private ruleForm = {
			username: '',
			phoneNum: '',
			gender: 1,
			age: '',
			certificateType: 1,
			certificateNumber: '',
			photo: '',
			companyCode: '',
			companyQualification: '',
			companyName: '',
			companyLicense: '',
			jobType: '',
      ethnic: 1,
      serviceCode: '',
      address:'武汉市武昌区',
      certificatePhoto: '',
      certificatePhotoBack: '',


		}

    private companyQualificationOptions= [
        { label: "营业执照", value: 1 },
        { label: "统一社会信用代码证书", value: 2 },
        { label: "卫生许可证", value: 3 },
        { label: "食品安全许可证", value: 4 },
        { label: "食品经营许可证", value: 5 },
        { label: "其他法定有效证件", value: 6 },
      ]
    private certificateTypeOptions: any[] = [
      { label: "居民身份证", value: 1 },
      { label: "护照", value: 3 },
      { label: "港澳居民来往内地通行证", value: 6 },
      { label: "台湾居民来往内地通行证", value: 7 },
      { label: "港澳台居民居住证", value: 8 },
      { label: "其他法定有效证件", value: 99 },
    ];
    private ethnicOptions: any[] = [
      { label: "无", value: 0 },
      { label: "汉族", value: 1 },
      { label: "蒙古族", value: 2 },
      { label: "回族", value: 3 },
      { label: "藏族", value: 4 },
      { label: "维吾尔族", value: 5 },
      { label: "苗族", value: 6 },
      { label: "彝族", value: 7 },
      { label: "壮族", value: 8 },
      { label: "布依族", value: 9 },
      { label: "朝鲜族", value: 10 },
      { label: "满族", value: 11 },
      { label: "侗族", value: 12 },
      { label: "瑶族", value: 13 },
      { label: "白族", value: 14 },
      { label: "土家族", value: 15 },
      { label: "哈尼族", value: 16 },
      { label: "哈萨克族", value: 17 },
      { label: "傣族", value: 18 },
      { label: "黎族", value: 19 },
      { label: "傈僳族", value: 20 },
      { label: "佤族", value: 21 },
      { label: "畲族", value: 22 },
      { label: "高山族", value: 23 },
      { label: "拉祜族", value: 24 },
      { label: "水族", value: 25 },
      { label: "东乡族", value: 26 },
      { label: "纳西族", value: 27 },
      { label: "景颇族", value: 28 },
      { label: "柯尔克孜族", value: 29 },
      { label: "土族", value: 30 },
      { label: "达斡尔族", value: 31 },
      { label: "仫佬族", value: 32 },
      { label: "羌族", value: 33 },
      { label: "布朗族", value: 34 },
      { label: "撒拉族", value: 35 },
      { label: "毛南族", value: 36 },
      { label: "仡佬族", value: 37 },
      { label: "锡伯族", value: 38 },
      { label: "阿昌族", value: 39 },
      { label: "普米族", value: 40 },
      { label: "塔吉克族", value: 41 },
      { label: "怒族", value: 42 },
      { label: "乌孜别克族", value: 43 },
      { label: "俄罗斯族", value: 44 },
      { label: "鄂温克族", value: 45 },
      { label: "德昂族", value: 46 },
      { label: "保安族", value: 47 },
      { label: "裕固族", value: 48 },
      { label: "京族", value: 49 },
      { label: "塔塔尔族", value: 50 },
      { label: "独龙族", value: 51 },
      { label: "鄂伦春族", value: 52 },
      { label: "赫哲族", value: 53 },
      { label: "门巴族", value: 54 },
      { label: "珞巴族", value: 55 },
      { label: "基诺族", value: 56 }
    ];

    private jobTypeOptions: any[] = [
      { label: "食品", value: 1 },
      { label: "乳制品", value: 2 },
      { label: "医药", value: 3 },
      { label: "美容", value: 4 },
      { label: "服务", value: 5 },
      { label: "饮用水", value: 6 },
      { label: "消毒产品生产", value: 7 },
      { label: "其他", value: 99 },
    ];

		private videoWidth= 1080
    private videoHeight = 1330
		private orderId: number = null
		private imgSrc = ""
    private certificateImgSrc = ""
    private currentPhotoType: 'photo' | 'certificatePhoto' | 'certificatePhotoBack' = 'photo'
    private certificateBackImgSrc = ""
    private isExpanded = false
    private thisCancas = null
		private thisContext = null
		private thisVideo = null
    private previewRAF: any = null
    private loadingbut = true
    private loading = false
    private options = []
    private showNotification = false
    private notificationTitle: string
    private notificationText: string
    private timer: any = null

    private tableData: []
    private loading2 = false
    private pagination = {
      page: 1,
      pageSize: 500,
      total: 1
    }
    private searchForm = {
      username: ''
    }
    private queryTimer: any
    private abortController: any
    private isProcessing: Boolean | boolean
    private shouldAbort: boolean
    private rawOptions: any[]
    private inputValue: any
    private uniqueKey: number
    private allowRender: boolean
    private searchQuery: ''
    private queryKeyword: ''
    private currentQuery = ''


    calculateSerialNumber(rowIndex) {
      return this.pagination.total - (this.pagination.page - 1) * this.pagination.pageSize - rowIndex;
    }
    formatGender(row, column) {
      return row.gender === 1 ? '男' : row.gender === 2 ? '女' : '未知';
    }

    get companyQualificationDisplay() {
      const selected = this.companyQualificationOptions.find(
        option => option.value === this.ruleForm.companyQualification
      );
      return selected ? selected.label : '';
    }
    get currentPreviewImg() {
      if (this.currentPhotoType === 'certificatePhoto') {
        return this.certificateImgSrc;
      } else if (this.currentPhotoType === 'certificatePhotoBack') {
        return this.certificateBackImgSrc;
      }
      return this.imgSrc;
    }    get jobTypeOptionsDisplay() {
      const selected = this.jobTypeOptions.find(
        option => option.value === this.ruleForm.jobType
      );
      return selected ? selected.label : '';
    }    get certificateTypeOptionsDisplay() {
      const selected = this.certificateTypeOptions.find(
        option => option.value === this.ruleForm.certificateType
      );
      return selected ? selected.label : '';
    }

    async fetchUserList() {
      this.loading2 = true; // 强制开启加载
      try {
        const res = await getUserList(this.pagination);
        if (res.data.code === 1) {
          // 用「新数组」赋值，确保触发 Vue 响应式更新（关键）
          this.tableData = [...res.data.data.records] || [];
          this.pagination.total = res.data.data.total || 0;
          console.log("初始化加载人员列表：", this.tableData); // 调试日志
        } else {
          this.tableData = [];
          this.pagination.total = 0;
          this.$message.warning("加载人员列表失败：" + res.data.msg);
        }
      } catch (error: any) {
        this.tableData = [];
        this.pagination.total = 0;
        console.error("加载人员列表异常：", error);
        this.$message.error("加载失败，请检查网络");
      } finally {
        // 强制关闭加载状态，用 $nextTick 确保 Vue 感知变化（关键修复）
        this.$nextTick(() => {
          this.loading2 = false;
        });
      }
    }

    syncPageValue(value) {
      const page = Number(value);
      // 验证页码有效性（必须是正整数，且不超过最大页码）
      if (!isNaN(page) && page > 0) {
        const maxPage = Math.ceil(this.pagination.total / this.pagination.pageSize) || 1;
        this.pagination.page = Math.min(page, maxPage); // 限制最大页码
      }
    }
    // 处理页码变化（包括“前往”和点击页码）
    handleCurrentChange(page) {
      this.pagination.page = page;
      this.fetchUserList(); // 刷新数据
    }
    // 处理每页条数变化
    handleSizeChange(pageSize) {
      this.pagination = { ...this.pagination, pageSize, page: 1 };
      this.fetchUserList();
    }


    imageChange(value: any) {
			this.ruleForm.companyLicense = value

     /* getDataByCert(value).then((response) => {
        // 假设你的后端返回的数据在 response.data 中
        const data = response.data;
        this.ruleForm.companyName = response.data.data.name
        this.ruleForm.companyCode = response.data.data.reg_num
        this.ruleForm.companyQualification = '1'
        if (response.data.data.sex === '男'){
          this.ruleForm.gender = 1
        }else if (response.data.data.sex === '女'){
          this.ruleForm.gender = 2
        }
        this.ruleForm.certificateType = '1'
        console.log(this.ruleForm.gender)

        // this.ruleForm.gender = data.sex

        // this.ruleForm.gender = data.
        // 在这里处理你的数据
        console.log('OCR Result:', data);

        // 根据需要更新你的状态或执行其他操作
        // 例如，更新表单或显示结果
        // this.ruleForm.ocrResult = data; // 假设你有一个 ocrResult 属性来存储结果
      }).catch((error) => {
        // 处理错误
        console.error('Error fetching OCR data:', error);
        // 显示错误消息或执行其他错误处理逻辑
        // this.showError('Failed to fetch OCR data'); // 假设你有一个 showError 方法来显示错误
      });
*/

    }
    photoChange(value: any) {
			this.ruleForm.photo = value
		}
    certificatePhotoChange(value: any) {
			this.ruleForm.certificatePhoto = value
		}
    certificatePhotoBackChange(value: any) {
      this.ruleForm.certificatePhotoBack = value
    }
    showImage(url) {
      this.dialogImageUrl = url;
      this.dialogVisible = true;
    }
//上传身份证照片调用api并回显数据
/*    photoChange2(value: any) {
      getDataByIdCard(value).then((response) => {
        this.ruleForm.username = response.data.data.name
        this.ruleForm.certificateNumber = response.data.data.num
        if (response.data.data.sex === '男'){
          this.ruleForm.gender = 1
        }else if (response.data.data.sex === '女'){
          this.ruleForm.gender = 2
        }
        this.ruleForm.certificateType = '1'
      }).catch((error) => {
        console.error('Error fetching OCR data:', error);
      });

    }*/
    showImage(url) {
      this.dialogImageUrl = url;
      this.dialogVisible = true;
    }

    openCamera(type: 'photo' | 'certificatePhoto' | 'certificatePhotoBack' = 'photo') {
      this.currentPhotoType = type
      this.isExpanded = true
      this.getCompetence()
    }

    getCompetence() {
      var _this = this;
      this.$nextTick(() => {
        this.thisCancas = document.getElementById("canvasCamera");
        this.thisContext = this.thisCancas.getContext("2d");
        this.thisVideo = document.getElementById("videoCamera");

        // 添加设备兼容性处理
        const constraints = {
          audio: false,
          video: {
            width: { ideal: this.videoWidth },
            height: { ideal: this.videoHeight }
          }
        };

        navigator.mediaDevices.getUserMedia(constraints)
          .then(function(stream) {
            // 确保视频元素存在
            if (!_this.thisVideo) {
              console.error("视频元素未找到");
              return;
            }

            _this.thisVideo.srcObject = stream;

            // 添加明确的播放处理
            _this.thisVideo.onloadedmetadata = function(e) {
              _this.thisVideo.play().catch(err => {
                console.error("视频播放失败:", err);
                _this.$message.error("请点击允许视频权限");
              });

              // 设置canvas尺寸
              _this.thisCancas.width = _this.videoWidth;
              _this.thisCancas.height = _this.videoHeight;

              // 启动实时预览绘制（与拍照使用同一套裁剪逻辑，保证预览与结果一致）
              _this.startPreview();
            };
          })
          .catch(err => {
            console.error("摄像头访问失败:", err);
            _this.$message.error("摄像头访问失败，请检查权限设置");
          });
      });
    }


//分离绘制逻辑
    startDrawing() {
      const _this = this;
            function draw() {
        if (!_this.thisVideo.paused && !_this.thisVideo.ended) {
              _this.thisContext.drawImage(
                _this.thisVideo,
                0, 0,
                _this.videoWidth,
                _this.videoHeight
              );
              requestAnimationFrame(draw);
            }
      }
            draw();
    }
    // 摄像头实时预览绘制：与 setImage 使用同一套裁剪参数，保证预览画面与拍照结果完全一致
    startPreview() {
      const _this = this;
      if (this.previewRAF) {
        cancelAnimationFrame(this.previewRAF);
        this.previewRAF = null;
      }
      const drawPreview = () => {
        if (_this.thisVideo && !_this.thisVideo.paused && !_this.thisVideo.ended) {
          const sw = _this.thisVideo.videoWidth;
          const sh = _this.thisVideo.videoHeight;
          const targetRatio = _this.videoHeight / _this.videoWidth; // 竖版比例，与预览框234x288一致
          let sx = 0, sy = 0, cw = sw, ch = sh;
          if (sw > 0 && sh > 0 && sw / sh > targetRatio) {
            // 视频源偏宽：按高度确定裁剪宽度，取中心区域
            cw = Math.round(sh * targetRatio);
            sx = Math.round((sw - cw) / 2);
          } else if (sw > 0 && sh > 0) {
            // 视频源偏高：按宽度确定裁剪高度，取中心区域
            ch = Math.round(sw / targetRatio);
            sy = Math.round((sh - ch) / 2);
          }
          _this.thisContext.drawImage(
            _this.thisVideo,
            sx, sy, cw, ch,
            0, 0,
            _this.videoWidth,
            _this.videoHeight
          );
        }
        _this.previewRAF = requestAnimationFrame(drawPreview);
      };
      this.previewRAF = requestAnimationFrame(drawPreview);
    }
		//  绘制图片（拍照功能）
    setImage() {
      // 停止实时预览，保留当前定格帧
      if (this.previewRAF) {
        cancelAnimationFrame(this.previewRAF);
        this.previewRAF = null;
      }
      // this.thisVideo.pause();
      var _this = this;
      // 从横向摄像头画面中裁剪出居中的竖版区域，避免整幅画面被拉伸导致人像变宽
      const sw = _this.thisVideo.videoWidth;
      const sh = _this.thisVideo.videoHeight;
      const targetRatio = _this.videoHeight / _this.videoWidth; // 竖版比例(1330/1080)，与预览框234x288一致
      let sx = 0, sy = 0, cw = sw, ch = sh;
      if (sw > 0 && sh > 0 && sw / sh > targetRatio) {
        // 视频源偏宽：按高度确定裁剪宽度，取中心区域
        cw = Math.round(sh * targetRatio);
        sx = Math.round((sw - cw) / 2);
      } else if (sw > 0 && sh > 0) {
        // 视频源偏高：按宽度确定裁剪高度，取中心区域
        ch = Math.round(sw / targetRatio);
        sy = Math.round((sh - ch) / 2);
      }
      // 点击，canvas画图（竖版，不变形）
      _this.thisContext.drawImage(
        _this.thisVideo,
        sx, sy, cw, ch,
        0, 0,
        _this.videoWidth,
        _this.videoHeight
      );

      // 获取图片base64链接（人像照输出PNG，与上传文件名test.png一致；证件照保持JPEG控制体积）
      var image;
      if (_this.currentPhotoType === 'photo') {
        // 人像照输出 PNG；若体积超过云端限制(1M)，降分辨率重绘压缩，保持 PNG 格式
        const rawPng = this.thisCancas.toDataURL("image/png");
        if (rawPng.length * 0.75 > 1024 * 1024) {
          _this.compressPngDataUrl(rawPng, 1024 * 1024).then((compressed) => {
            _this.imgSrc = compressed;
          });
        } else {
          _this.imgSrc = rawPng;
        }
      } else {
        image = this.thisCancas.toDataURL("image/jpeg", 0.92);
        // 根据拍照类型写入不同的 imgSrc，避免个人照片的 ImageUpload 误捕获
        if (_this.currentPhotoType === 'certificatePhoto') {
          _this.certificateImgSrc = image;
        } else if (_this.currentPhotoType === 'certificatePhotoBack') {
          _this.certificateBackImgSrc = image;
        }
        else {
          _this.imgSrc = image;
        }
      }

      // 隐藏摄像头画面，显示拍照结果
      // this.thisVideo.style.display = "block";
      // this.thisCancas.style.display = "none"; // 隐藏canvas
      // document.getElementById("photoResult").style.display = "block"; // 显示图片
    }
    // 人像照 PNG 体积压缩：等比降分辨率重绘，直到体积低于 maxBytes（保持 PNG 格式）
    compressPngDataUrl(dataUrl, maxBytes) {
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
          const estBytes = dataUrl.length * 0.75;
          if (estBytes <= maxBytes) {
            resolve(dataUrl);
            return;
          }
          // 按体积比例估算缩放系数，留 10% 余量
          const scale = Math.sqrt(maxBytes / estBytes) * 0.9;
          const w = Math.max(200, Math.round(img.width * scale));
          const h = Math.max(200, Math.round(img.height * scale));
          const compress = (cw, ch) => {
            const canvas = document.createElement('canvas');
            canvas.width = cw;
            canvas.height = ch;
            const ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0, cw, ch);
            const out = canvas.toDataURL('image/png');
            if (out.length * 0.75 > maxBytes && cw > 200) {
              compress(Math.round(cw * 0.8), Math.round(ch * 0.8));
            } else {
              resolve(out);
            }
          };
          compress(w, h);
        };
        img.onerror = () => resolve(dataUrl);
        img.src = dataUrl;
      });
    }
    //对话框打开事件处理
    handleDialogOpen() {
      this.$nextTick(() => {
        this.initCameraElements();
        this.getCompetence();
        if (this.currentPhotoType === 'certificatePhoto') {
          this.certificateImgSrc = '';
        } else if (this.currentPhotoType === 'certificatePhotoBack') {
          this.certificateBackImgSrc = '';
        } else {
          this.imgSrc = '';
        }
      });
    }

    //对话框关闭事件处理
    handleDialogClose() {
      this.stopCameraStream();
    }

    //初始化方法
    initCameraElements() {
      // 重置元素显示状态
      this.thisVideo = document.getElementById("videoCamera");
      this.thisCancas = document.getElementById("canvasCamera");
      this.thisVideo.style.display = "none";
      this.thisCancas.style.display = "block";
      document.getElementById("photoResult").style.display = "none";
    }

    //停止摄像头方法
    stopCameraStream() {
      // 停止实时预览绘制
      if (this.previewRAF) {
        cancelAnimationFrame(this.previewRAF);
        this.previewRAF = null;
      }
      if (this.thisVideo && this.thisVideo.srcObject) {
        this.thisVideo.srcObject.getTracks().forEach(track => track.stop());
        this.thisVideo.srcObject = null;
      }
    }
		// base64转文件
		dataURLtoFile(dataurl, filename) {
		var arr = dataurl.split(",");
		var mime = arr[0].match(/:(.*?);/)[1];
		var bstr = atob(arr[1]);
		var n = bstr.length;
		var u8arr = new Uint8Array(n);
		while (n--) {
			u8arr[n] = bstr.charCodeAt(n);
		}
		return new File([u8arr], filename, { type: mime });
		}
		// 上传图片
    handleCameraSubmit() {
      if (this.currentPhotoType === 'certificatePhoto') {
        this.uploadCertificateImg();
      } else if (this.currentPhotoType === 'certificatePhotoBack') {
        this.uploadCertificateBackImg();
      }
      else {
        this.uploadImg();
      }
    }
		uploadImg() {
		var _this = this;
		var file = this.dataURLtoFile(this.imgSrc, "test.png");
		if (file.size / 1024 / 1024 > 2) {
			_this.$message.error("上传文件大小不能超过2M!");
			return;
		}
		var formData = new FormData();
		formData.append("file", file);
		_this.loadingbut = true;
		uploadFile(file)
		.then(function (response) {
			_this.loadingbut = false;
			if (response.data.code===1) {
				_this.ruleForm.photo = response.data.data;

				_this.$message.success("上传成功");
        _this.isExpanded = false;
			} else {
				_this.$message.error(response.data.msg || "上传失败");
			}
			})
		.catch(function (error) {
			_this.loadingbut = false;
			_this.$message.error("上传过程中发生错误");
			});
		}
    uploadCertificateImg() {
		var _this = this;
		var file = this.dataURLtoFile(this.certificateImgSrc, "test.png");
		if (file.size / 1024 / 1024 > 2) {
			_this.$message.error("上传文件大小不能超过2M!");
			return;
		}
		var formData = new FormData();
		formData.append("file", file);
		_this.loadingbut = true;
		uploadFile(file)
		.then(function (response) {
			_this.loadingbut = false;
			if (response.data.code===1) {
				_this.ruleForm.certificatePhoto = response.data.data;

				_this.$message.success("上传成功");
        _this.isExpanded = false;
			} else {
				_this.$message.error(response.data.msg || "上传失败");
			}
			})
		.catch(function (error) {
			_this.loadingbut = false;
			_this.$message.error("上传过程中发生错误");
			});
		}

    uploadCertificateBackImg() {
      var _this = this;
      var file = this.dataURLtoFile(this.certificateBackImgSrc, "test.png");
      if (file.size / 1024 / 1024 > 2) {
        _this.$message.error("上传文件大小不能超过2M!");
        return;
      }
      var formData = new FormData();
      formData.append("file", file);
      _this.loadingbut = true;
      uploadFile(file)
        .then(function (response) {
          _this.loadingbut = false;
          if (response.data.code===1) {
            _this.ruleForm.certificatePhotoBack = response.data.data;

            _this.$message.success("上传成功");
            _this.isExpanded = false;
          } else {
            _this.$message.error(response.data.msg || "上传失败");
          }
        })
        .catch(function (error) {
          _this.loadingbut = false;
          _this.$message.error("上传过程中发生错误");
        });
    }
		// 关闭摄像头
		stopNavigator() {
		this.thisVideo.srcObject.getTracks()[0].stop();
		}



    private isCellPhone(val: any): boolean {
      const cleanVal = String(val).replace(/[\s-+()]/g, '');
      return /^1[3-9]\d{9}$/.test(cleanVal);
    }

    private checkUsername(rule : any, value : String, callback : any) {
      if (!value) {
        callback(new Error('请输入预约人姓名'))
      } else {
        // const reg = /^[\u4e00-\u9fa5_a-zA-Z]{1,12}$/
        // if (!reg.test(value)) {
        //   callback(new Error('姓名输入不符，请输入1-12个字符'))
        // } else {
        //   callback()
        // }
        callback()
      }
    }

    private checkAge(rule : any, value : any, callback : any) {
      if (value === '' || value === null || value === undefined) {
        callback(new Error('请输入年龄'));
        return;
      }
      const num = Number(value);
      if (isNaN(num)) {
        callback(new Error('年龄必须为有效数字'));
        return;
      }
      if (num < 16) {
        callback(new Error('年龄必须≥16岁'));
      } else if (num > 200) {
        callback(new Error('???'));
      } else {
        callback();
      }
    }

    private checkServiceCode(rule : any, value : any, callback : any) {
      if (value === '' || value === null || value === undefined) {
        callback(new Error('请输入体检编号'));
        return;
      }
      if (!/^\d{12}$/.test(String(value))) {
        callback(new Error('体检编号必须为12位数字！'));
        return;
      }
      callback();
    }

    private handleServiceCodeInput(value: string) {
      this.ruleForm.serviceCode = value.replace(/\D/g, '').slice(0, 12);
    }
		private checkPhone(rule : any, value : any, callback : any) {
			// let phoneReg = /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/;
			if (value == '') {
				callback(new Error('请输入手机号'))
			} else if (!this.isCellPhone(value)) {
				//引入methods中封装的检查手机格式的方法
				callback(new Error('请输入正确的手机号!'))
			} else {
				callback()
			}
		}

		private validID(rule : any, value : any, callback : any) {
			// 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
			let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
			if (value == '') {
				callback(new Error('请输入身份证号码'))
			} else if (reg.test(value)) {
				callback()
			} else {
				callback(new Error('身份证号码不正确'))
			}
		}
    // private validID(rule: any, value: any, callback: any) {
    //   // 获取当前选择的证件类型
    //   const certificateType = this.ruleForm.certificateType;
    //
    //   // 定义身份证的正则表达式
    //   const residentIdCardPattern = /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/;
    //
    //   if (!value) {
    //     callback(new Error('请输入证件号码'));
    //     return;
    //   }
    //
    //   // 只有当证件类型为居民身份证时才进行格式验证
    //   if (certificateType === 1) { // 居民身份证
    //     if (residentIdCardPattern.test(value)) {
    //       callback();
    //     } else {
    //       callback(new Error('身份证号码格式不正确'));
    //     }
    //   } else {
    //     // 对其他证件类型不做格式限制，直接通过
    //     callback();
    //   }
    // }

    private validID(rule: any, value: any, callback: any) {
      if (!value) {
        callback(new Error('请输入证件号码'));
        return;
      }

      if (this.isCertificateValid(value)) {
        callback();
      } else {
        callback(new Error('身份证号码格式不正确'));
      }
    }

    isCertificateValid(value: string): boolean {
      if (!value) return false;

      // 当证件类型为居民身份证时进行格式验证
      if (this.ruleForm.certificateType === 1) {
        return /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/.test(value);
      }

      // 其他证件类型不做格式限制
      return true;
    }

    handleCertificateInput(value: string) {
      if (this.isCertificateValid(value)) {
        this.getByIdcard(value);
      }
    }

		get rules() {
			return {

        username: [{ required: true, validator: this.checkUsername, trigger: 'blur' }],
        age: [{ required: true, validator: this.checkAge, trigger: 'blur' }],
        serviceCode: [{ required: true, validator: this.checkServiceCode, trigger: 'blur' }],
				phoneNum: [{ required: true, validator: this.checkPhone, trigger: 'blur' }],
        certificateNumber: [{ required: true, validator: this.validID, trigger: 'blur' }],
        certificateType: [{ required: true, trigger: 'blur' }],
        gender: [{ required: true, trigger: 'blur' }],
        companyCode: [{ required: true, trigger: 'blur' }],
        companyQualification: [{ required: true, trigger: 'blur' }],
        companyName: [{ required: true, trigger: 'blur' }],
        jobType: [{ required: true, trigger: 'blur' }],
        ethnic: [{ required: true, trigger: 'blur' }],
        photo: [{ required: true, trigger: 'blur' }],
        address: [{ required: true, trigger: 'blur' }],
        certificatePhoto: [{ required: true, trigger: 'blur' }],
        certificatePhotoBack: [{ required: true, trigger: 'blur' }]
			}
		}

		async checkCompanyName(companyName : string) {
			getCompanyByCompanyName(companyName).then((res : any) => {
				if(res.data.code === 1) {
					let companyInfo = `
						企业资质证件号码：${res.data.data.companyCode}<br>
						企业资质类型：${this.getDisplayCompanyQualificationType(res.data.data.companyQualification)}<br>
						公司名称：${res.data.data.companyName}<br>
						工种类型：${this.getDisplayJobType(res.data.data.jobType)}
					`;
					this.$confirm(`是否使用已有数据补充企业信息?<br><br>${companyInfo}`, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
						dangerouslyUseHTMLString: true, // 允许使用HTML格式
					}).then(() => { // 用户点击了确定按钮
						this.ruleForm.companyCode = res.data.data.companyCode;
						// this.ruleForm.companyLicense = res.data.data.companyLicense;
						this.ruleForm.companyQualification = res.data.data.companyQualification;
						this.ruleForm.companyName = res.data.data.companyName;
						this.ruleForm.jobType = res.data.data.jobType;
						this.$message.success("已补充该公司信息")
					}).catch(() => { // 用户点击了取消按钮

					});
				} else {
				}
			})
		}
    getByIdcard(certificateNumber) {
      if (this.ruleForm.certificateNumber.length === 18) {
        const sexNum = this.ruleForm.certificateNumber.substring(16, 17); // 获取身份证号的第17位
        // 基本格式校验
        const reg = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if (!reg.test(this.ruleForm.certificateNumber)) {
          this.$message.error('身份证号格式错误（必须为18位，最后一位可为X）');
          return false;
        }

        // 校验码验证
        const Wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
        const ValideCode = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];

        let sum = 0;
        try {
          // 前17位必须为数字
          for (let i = 0; i < 17; i++) {
            const num = parseInt(this.ruleForm.certificateNumber.substring(i, i + 1), 10);
            if (isNaN(num)) {
              this.$message.error('身份证号格式错误');
              return false;
            }
            sum += num * Wi[i];
          }
        } catch (e) {
          this.$message.error('身份证号格式错误');
          return false;
        }

        // 校验第18位
        const code = this.ruleForm.certificateNumber.substring(17).toUpperCase();
        const valCodePosition = sum % 11;

        if (code !== ValideCode[valCodePosition]) {
          this.$message.error('身份证号校验不正确');
          return false;
        }
        this.ruleForm.gender = sexNum % 2 === 1 ? 1 : 2; // 判断性别
        this.$forceUpdate(); // 强制更新视图
        console.log("性别身份证号判断"+this.ruleForm.gender)
      } else {
        this.ruleForm.gender = null; // 如果身份证号不是18位，清空性别
      }

      const params = {
        certificateNumber: this.ruleForm.certificateNumber, // 证件号码
        photo: this.ruleForm.photo, // 照片
        ethnic: this.ruleForm.ethnic ,
      }

      if(this.actionType === "add") {//只在新增时执行证件号查询和跳转
        queryResvDetailByCertificateNumber({ ...params })
          .then(res => {
            if (res.data.data) {
              this.$message({
                message: '线上预约',
                type: 'warning'
              });
              this.orderId = res.data.data;
              // this.$router.push({ path: '/orderDetails/add' })
// 跳转到添加页面并携带id参数，从而切换到更新模式
              this.$router.push({
                path: '/orderDetails/add',
                query: { id: this.orderId } // 带上id参数
              });
            }
            if (this.$route.query.id) {
              this.title = '线上预约';
              console.log("跳转111")

              // 调用后端 API 获取预约详情
              queryResvDetailById(this.$route.query.id).then(res => {
                if (res.data.code === 1) {
                  this.ruleForm = res.data.data
                  this.imgSrc = this.ruleForm.photo
                  this.imageUrl = this.ruleForm.companyLicense
                  console.log("跳转111成功")

                } else {
                  console.error('Failed to fetch reservation details:', res.data.message);
                }
              }).catch(error => {
                // 处理网络错误或其他异常
                console.error('An error occurred:', error);
              });
            }
          })
          // queryResvDetailById(orderId).then(res => {
          //   if(res.data.code === 1) {
          //     this.ruleForm = res.data.data
          //   }
          // })

          // console.log("actionType==="+this.actionType)

          // this.$confirm('线上预约是否直接打印体检表?', '提示', {
          //   confirmButtonText: '确定',
          //   cancelButtonText: '取消',
          //   type: 'warning',
          // }).then(() => {
          //   //直接打印体检表
          //   this.$message("正在打印体检表请稍后");
          // this.showWord(orderId);

          // this.imgSrc = null;
          // this.imageUrl = null;
          // this.ruleForm = {
          //   username: '',
          //   phoneNum: '',
          //   gender: 1,
          //   age: '',
          //   certificateType: 1,
          //   certificateNumber: '',
          //   photo: null,
          //   companyCode: '',
          //   companyQualification: '',
          //   companyName: '',
          //   companyLicense: null,
          //   jobType: '',
          //   ethnic: 1
          // }
          // this.$router.push({ path: '/dish' })


          .catch(error => {
            // 处理错误，比如显示一个错误消息
            console.error(error);
          });
      }
    }
    submitForm(formName: any, st: any) {
      // 1. 表单验证回调改为 async，支持 await 异步操作
      (this.$refs[formName] as any).validate(async (valid: any) => {
        if (valid) {
          this.loading2 = true; // 2. 提交开始，开启加载状态（同步表格遮罩）
          try {
            if (this.actionType === 'add') {
              const params = { ...this.ruleForm };
              console.log(this.ruleForm)
              // 3. await 等待 addOrder 提交完成，避免异步导致的刷新时机错误
              const res: any = await addOrder(params);
              if (res.data.code === 1) {
                console.log(res.data);
                console.log(res.data.data);
                this.$message.success('预约信息添加成功！');
                this.orderId = res.data.data;

                if (st) { // 线下预约直接审核成功，保存并打印
                  console.log(this.orderId);
                  this.showWord(this.orderId);
                }

                // 重置表单（与原逻辑一致）
                this.imgSrc = null;
                this.imageUrl = null;
                this.ruleForm = {
                  username: '',
                  phoneNum: '',
                  gender: 1,
                  age: '',
                  certificateType: 1,
                  certificateNumber: '',
                  photo: null,
                  companyCode: '',
                  companyQualification: '',
                  companyName: '',
                  companyLicense: null,
                  jobType: '',
                  ethnic: 1,
                  serviceCode: '',
                  address:'武汉市武昌区',
                  certificatePhoto: '',
                  certificatePhotoBack: ''
                };

                // 4. 关键修改：提交成功后，主动调用列表刷新（替代 window.reload）
                await this.fetchUserList();
                this.playSystemLikeSound();
                console.log("111111111111111111111111111111111111111")
              } else {
                this.$message.error(res.data.msg);
              }
            } else { // 修改操作（同步添加 loading 控制，可选但建议统一）
              const params = { ...this.ruleForm };
              const res: any = await updateOrder(params);
              if (res.data.code === 1) {
                this.$message.success('信息保存成功！');
                console.log("?????st" + st);
                if (st) {
                  this.showWord(this.orderId);
                }
                this.$router.push('/dish');
              } else {
                this.$message.error('网络错误！');
                console.log("?????" + st);
              }

              // 重置表单（与原逻辑一致）
              this.imgSrc = null;
              this.imageUrl = null;
              this.ruleForm = {
                username: '',
                phoneNum: '',
                gender: 1,
                age: '',
                certificateType: 1,
                certificateNumber: '',
                photo: null,
                companyCode: '',
                companyQualification: '',
                companyName: '',
                companyLicense: null,
                jobType: '',
                ethnic: 1,
                serviceCode: '',
                address:'武汉市武昌区',
                certificatePhoto: '',
                certificatePhotoBack: ''
              };
              console.log("?????" + this.ruleForm);
            }
            this.playSystemLikeSound();
            console.log("111111111111111111111111111111111111111")
          } catch (error: any) {
            console.log('请求出错了：' + (error.message || '未知错误'))
            this.$message.error('网络错误！');
            console.error('提交失败：', error);
          } finally {
            // 5. 无论成功失败，都关闭加载状态（确保表格遮罩消失）
            this.loading2 = false;
          }
        } else {
          this.$message.warning('表单验证失败，请检查必填项！');
          return false;
        }
        // ❌ 原逻辑：fetchUserList() 放在这里会提前执行（addOrder 还没完成），已移除
      });
    }
    async showWord(id: any) {
      this.loading = true;
      // const orderId = row.id;
      // 调用orderPrint函数并处理返回的Promise
      try {
        const data = await orderPrint(id); // 直接等待orderPrint的结果
        // 假设res是包含PDF文档流数据的ArrayBuffer或其他可转换为Blob的格式
        const blob = new Blob([data], { type: 'application/pdf' });

        // 创建一个iframe用于打印
        const iframe = document.createElement('iframe');
        (iframe.style as any).frameborder = '0'; // 注意这里应该是'0'而不是'no'
        iframe.style.display = 'none';
        iframe.setAttribute('id', 'printPdf');
        iframe.setAttribute('name', 'printPdf');

        // 将Blob的URL设置为iframe的源
        iframe.src = window.URL.createObjectURL(blob);

        // 将iframe添加到文档中
        document.body.appendChild(iframe);
        // 监听iframe加载完成
        iframe.onload = () => {
          try {
            const ordonnance = iframe.contentWindow;
            if (ordonnance && ordonnance.document) {
              ordonnance.document.execCommand('print', false, null);
            }
            // 清理：如果不需要显示PDF，这里不需要更改display属性
            // document.body.removeChild(iframe);
            // window.URL.revokeObjectURL(iframe.src);
            this.loading = false;

            // this.$router.push({ path: '/dish' });

          } catch (error) {
            this.loading = false;
            console.error('Failed to print PDF:', error);
            // 显示错误或进行其他处理
          }
        };

/*
        document.body.appendChild(iframe);

        // 可选：添加一个按钮来控制iframe的显示
        const showPdfButton = document.createElement('button');
        showPdfButton.textContent = '显示PDF';
        showPdfButton.onclick = () => {
          iframe.style.display = iframe.style.display === 'none' ? 'block' : 'none';
        };
        document.body.appendChild(showPdfButton);
*/

      } catch (error) {
        console.error('请求失败:', error);
      }
    }



		getDisplayCompanyQualificationType(type) {
			const qualifications = {
				'1': '营业执照',
				'2': '统一社会信用代码证书',
				'3': '卫生许可证',
				'4': '食品安全许可证',
				'5': '食品经营许可证',
				'6': '其他法定有效证件'
			};
			return qualifications[type] || '未知证件类型';
		}

		getDisplayJobType(type) {
			const jobType = {
				'1': '食品',
				'2': '乳制品',
				'3': '医药',
				'4': '美容',
				'5': '服务',
				'6': '饮用水',
				'7': '消毒产品生产',
				'99': '其他'
			};
			return jobType[type] || '未知工种类型';
		}

    getDisplayCertificateType(type) {
      const CertificateType = {
        '1': '居民身份证',
        '2': '外国人居住证',
        '3': '港澳台居住证',
        '4': '军官证',
        '5': '驾驶证',
        '6': '港澳居民来往内地通行证',
        '7': '台湾居民来往内地通行证',
        '8': '护照',
        '98': '中国人民武装警察身份证件',
        '99': '其他法定有效证件'
      };
      return CertificateType[type] || '未知证件类型';
    }

    //页面滚动
    scrollToBottom() {
      const element = this.$refs.scrollToBottom;
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    getGender(certificateNumber){

      if (certificateNumber.length === 18) {
        const sexNum = certificateNumber.substring(16, 17); // 获取身份证号的第17位
        this.ruleForm.gender = sexNum % 2 === 1 ? 1 : 2; // 判断性别
        this.$forceUpdate(); // 强制更新视图
        console.log("性别身份证号判断"+this.ruleForm.gender)
      } else {

        this.ruleForm.gender = null; // 如果身份证号不是18位，清空性别
      }
    }
    getInfoCard(){

      axios.get('http://127.0.0.1:24010/ZKIDROnline/ScanReadIdCardInfo?OP-DEV=1&CMD-URL=4&REPEAT=1&READTYPE=1')
        .then(response => {
          // 假设服务器返回的数据格式是JSON，并且包含一个名为Certificate的对象
          const certificate = response.data.Certificate;
          this.ruleForm.username = certificate.Name;
          // this.ruleForm.gender = certificate.Sex === 1 ? 1 : 2;//1为男，2为女

          this.ruleForm.certificateNumber = `${certificate.IDNumber}`;
          this.getGender(this.ruleForm.certificateNumber)

          this.ruleForm.certificateType = 1;
          this.ruleForm.ethnic = Number(certificate.NationCode);

          // 假设你有其他逻辑需要在这里执行，比如更新UI或发送数据到服务器

          this.scrollToBottom();
          //如果是线上预约的用户进行一个查询操作，后面将actionType设置为更新操作
          // // 处理身份证照片（Base64编码）
          // 获取图片base64链接
          var _this = this;
          // 确保Base64字符串格式正确
          var image1 = `data:image/jpeg;base64,${certificate.Base64Photo}`;
          _this.imgSrc = image1;
          var file1 = this.dataURLtoFile(_this.imgSrc, "test2.png");
          var formData1 = new FormData();
          formData1.append("file1", file1);
          _this.loadingbut = true;
          uploadFile(file1)
            .then((response) => {
              this.loadingbut = false;
              if (response.data.code === 1) {
                this.ruleForm.photo = response.data.data;
                console.log("photo111"+this.ruleForm.photo);
                this.$message.success("上传成功");
                console.log("photo2222"+this.ruleForm.photo);

                const params = {
                  certificateNumber: this.ruleForm.certificateNumber, // 证件号码
                  photo: this.ruleForm.photo, // 照片
                  ethnic: this.ruleForm.ethnic ,
                }

                queryResvDetailByCertificateNumber({ ...params })
                  .then(res => {
                    if (res.data.data && !this.hasRedirected) { // 检查状态标志
                      this.hasRedirected = true; // 设置状态标志为已跳转
                      this.$message({
                        message: '线上预约',
                        type: 'warning'
                      });
                      // const orderId = res.data.data;

                      this.getByIdcard(this.ruleForm.certificateNumber)


                     /* queryResvDetailById(orderId).then(res => {
                        if(res.data.code === 1) {
                          this.ruleForm = res.data.data
                          console.log("跳转111成功")

                        }
                      })

                      // console.log("actionType==="+this.actionType)

                      this.$confirm('线上预约是否直接打印体检表?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                      }).then(() => {
                        //直接打印体检表
                        this.$message("正在打印体检表请稍后");
                        this.showWord(orderId);

                        this.imgSrc = null;
                        this.imageUrl = null;
                        this.ruleForm = {
                          username: '',
                          phoneNum: '',
                          gender: 1,
                          age: '',
                          certificateType: 1,
                          certificateNumber: '',
                          photo: null,
                          companyCode: '',
                          companyQualification: '',
                          companyName: '',
                          companyLicense: null,
                          jobType: '',
                          ethnic: 1
                        }
                        // this.$router.push({ path: '/dish' })

                      }).catch(() => {
                        this.$message({
                          type: 'info',
                          message: '已取消打印体检表',
                        });
                      });*/
                    } else {
                      this.actionType = "add";
                    }
                  })
                  .catch(error => {
                    // 处理错误，比如显示一个错误消息
                    console.error(error);
                  });


              } else {
                this.$message.error(response.data.msg || "上传失败");
              }
            })
            .catch((error) => {
              this.loadingbut = false;
              this.$message.error("上传过程中发生错误");
            });

        })
        .catch(error => {
          // 处理错误，比如显示一个错误消息
          console.error('读取身份证信息时出错:', error);
          // 假设你有一个名为Smessage的对象，它有一个error方法来显示错误消息
          // this.Smessage.error('请将身份证放在读卡器上方');
        });
    }


		created() {
      // 根据是否有 id 查询参数来判断是添加还是更新操作
      this.actionType = this.$route.query.id ? "update" : "add";

			if(this.$route.query.id) {
        this.title = '修改预约信息';
        console.log("跳转2222")
        // 调用后端 API 获取预约详情
				queryResvDetailById(this.$route.query.id).then(res => {
					if(res.data.code === 1) {
            this.ruleForm = res.data.data
            this.imgSrc = res.data.data.photo
            this.imageUrl = res.data.data.companyLicense
            this.certificateImgSrc = res.data.data.certificatePhoto
            this.certificateBackImgSrc = res.data.data.certificatePhotoBack
            console.log("跳转2222成功")

          } else {
            console.error('Failed to fetch reservation details:', res.data.message);
					}
        }).catch(error => {
          // 处理网络错误或其他异常
          console.error('An error occurred:', error);
        });
			}
		}


    handleKeydown(e) {
      // 只有按回车键时才触发查询
      if (e.key === 'Enter') {
        e.preventDefault(); // 阻止默认行为（避免表单提交等）
        // 通过ref获取输入框的值
        const inputValue = this.$refs.companySelect.query;
        this.fetchOptions(inputValue);
      }
    }

    fetchOptions(query) {


      const safeQuery = query.trim();

      // 输入长度验证
      if (safeQuery.length < 4) {
        this.options = [];
        this.allowRender = false;
        return;
      }


      this.allowRender = false;


      // 清除定时器（如果存在）
      if (this.queryTimer) {
        clearTimeout(this.queryTimer);
      }

      // 立即执行查询（移除不必要的延迟）
      const self = this;
      this.options = [];

      console.log('发送查询请求:', safeQuery);  // 调试日志

      // 发送网络请求
      companyFuzzyQuery(safeQuery)
        .then(function(response) {
          console.log('收到查询结果:', response);  // 调试日志

          const rawData = self.extractRawData(response) || [];
          const validData = rawData.filter(item => {
            return item && typeof item === 'object' && !Array.isArray(item);
          });

          const safeOptions = validData.slice(0, 15).map((item, index) => {
            const value = item.creditNo || item.id || `fixed_key_${index}`;
            const isCancelled = item.companyStatus === "注销";

            return {
              value: value,
              label: item.companyName || `未知企业_${index}`,
              disabled: isCancelled,
              isCancelled: isCancelled
            };
          });

          self.$nextTick(() => {
            self.options = safeOptions;
            self.allowRender = true;
            self.loading = false;

            // 显示下拉框
            if (self.$refs.companySelect) {
              self.$refs.companySelect.toggleDropdown();
            }
          });
        })
        .catch(function(error) {
          console.error("查询失败:", error);
          self.options = [];
          self.allowRender = true;
          self.loading = false;
          self.$message.error('查询失败，请稍后重试');
        });
    }

    extractRawData(response) {
      try {
        if (!response || !response.data) return [];
        const data1 = response.data;
        const data2 = data1.data || {};
        const data3 = data2.data || {};
        const data4 = data3.data || [];
        return Array.isArray(data4) ? data4 : [];
      } catch (e) {
        console.error("数据提取失败:", e);
        return [];
      }
    }

  beforeDestroy() {
    if (this.queryTimer) clearTimeout(this.queryTimer);
  }




    handleCompanyChange(value) {
      const selectedOption = this.options.find(option => option.value === value);
      if (selectedOption) {
        this.ruleForm.companyName = selectedOption.label;
        this.ruleForm.companyCode = selectedOption.value;
      }
    }


    async mounted() { // 改为 async 支持 await
                      // 1. 优先加载人员列表，等待加载完成
      await this.fetchUserList();

      // 2. 加载完成后，再启动自动刷新定时器（避免冲突）
      this.timer = setInterval(() => {
        queryResvDetail().then(res => {
          if (res.data.code === 1 && res.data.data.status === 1) {
            this.showNotification = true;
            this.notificationTitle = '预约管理尚未审核';
          }
        });
      }, 300000); // 5分钟

      // 3. 双向监听表单字段变化（不受影响）
      this.$watch(
        () => [this.ruleForm.certificateType, this.ruleForm.certificateNumber],
        () => this.handleAge()
      );

      try {
        // 兼容不同浏览器的 AudioContext
        window.AudioContext = window.AudioContext || window.webkitAudioContext
        this.audioContext = new AudioContext()
      } catch (err) {
        console.warn('当前浏览器不支持Web Audio API，无法播放提示音：', err)
      }
    }

    beforeDestroy() {
      if (this.queryTimer) clearTimeout(this.queryTimer);
      this.isProcessing = false; // 停止处理
    }

    playSystemLikeSound() {
      if (!this.audioContext) return

      const { type, initFreq, endFreq, volume, duration, fadeTime } = this.soundConfig

      // 创建振荡器（负责生成声音）
      const oscillator = this.audioContext.createOscillator()
      // 创建音量控制器
      const gainNode = this.audioContext.createGain()

      // 连接音频链路：振荡器 → 音量 → 扬声器
      oscillator.connect(gainNode)
      gainNode.connect(this.audioContext.destination)

      // 1. 调整音色
      oscillator.type = 'square'

      // 2. 调整音调（初始值 + 渐变）
      oscillator.frequency.setValueAtTime(initFreq, this.audioContext.currentTime)
      // 音调从 initFreq 渐变到 endFreq，耗时 fadeTime 秒
      oscillator.frequency.exponentialRampToValueAtTime(
        endFreq,
        this.audioContext.currentTime + fadeTime
      )

      // 3. 调整音量（初始值 + 渐变，避免突然结束）
      gainNode.gain.setValueAtTime(volume, this.audioContext.currentTime)
      gainNode.gain.exponentialRampToValueAtTime(
        0.001,  // 最终音量接近0，避免爆音
        this.audioContext.currentTime + fadeTime
      )

      // 4. 调整播放时长
      oscillator.start()
      oscillator.stop(this.audioContext.currentTime + duration)
    }

    private handleAge() {
      if (this.ruleForm.certificateType === 1) { // 居民身份证类型
        const idNumber = this.ruleForm.certificateNumber;
        if (this.isValidIDNumber(idNumber)) {
          const age = this.calculateAge(idNumber);
          if (age !== null) {
            this.ruleForm.age = age.toString();
          }
        }
      }
    }

    private isValidIDNumber(idNumber: string): boolean {
      return [18].includes(idNumber.length);
    }

    private calculateAge(idNumber: string): number | null {
      // 提取出生日期
      let birthYear: number, birthMonth: number, birthDay: number;

      try {
        if (idNumber.length === 18) {
          birthYear = parseInt(idNumber.substr(6, 4));
          birthMonth = parseInt(idNumber.substr(10, 2)) - 1;
          birthDay = parseInt(idNumber.substr(12, 2));
        } else {
          return null;
        }
      } catch {
        return null;
      }

      // 验证日期有效性
      const birthDate = new Date(birthYear, birthMonth, birthDay);
      if (isNaN(birthDate.getTime())) return null;

      // 计算年龄
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();

      if (monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }

      return age > 0 ? age : 0;
    }

    // 身份证号验证
    isValidIdCard(idCard) {
      // 空值处理
      if (!idCard || typeof idCard !== 'string') return false;

      // 去除空格
      idCard = idCard.trim();

      // 基本格式校验
      const reg = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (!reg.test(idCard)) {
        return false;
      }

      // 校验码验证
      const Wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      const ValideCode = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];

      let sum = 0;
      // 前17位必须为数字
      for (let i = 0; i < 17; i++) {
        const num = parseInt(idCard.substring(i, i + 1), 10);
        if (isNaN(num)) {
          return false;
        }
        sum += num * Wi[i];
      }

      // 校验第18位
      const code = idCard.substring(17).toUpperCase();
      const valCodePosition = sum % 11;

      return code === ValideCode[valCodePosition];
    }

    // 获取身份证号提示信息
    getCertificateTooltip(row) {
      if (!row.certificateNumber) {
        return '身份证号为空';
      }

      // 先进行格式校验
      const reg = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (!reg.test(row.certificateNumber)) {
        return '身份证号格式错误（必须为18位，最后一位可为X）';
      }

      if (!this.isValidIdCard(row.certificateNumber)) {
        return '身份证号校验码错误，不是有效的身份证号';
      }

      return row.certificateNumber;
    }

	}
